import config from "@shared/config/client";
import {
  withAuthenticatedClientRequest,
  withClientRequest,
} from "../requestBuilder/withClientRequest";
import requests from "./requests";
import { Collection, CreateCollection } from "./types";
import { ICallableRequestBuilder } from "../requestBuilder/types";
import { enrichItem, exportAddressesByProperties } from "../helpers";
import { EnrichedObject, EnrichmentProperties } from "../types";

const validateSlug = async (slug: string) => {
  const res = await fetch(
    `${config.apiUrl}/collections/validate-slug/${slug}`,
    { method: "POST" },
  );

  const isValid = await res.json();

  return !!isValid;
};

const create =
  (request: ICallableRequestBuilder<CreateCollection>) =>
  (collection: Collection) => {
    return request.call(`${config.apiUrl}/collections`, (init) => ({
      ...init,
      method: "POST",
      headers: {
        ...init.headers,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ collection }),
    }));
  };

const mintForFree =
  (request: ICallableRequestBuilder<CreateCollection>) => (nftId: string) => {
    return request.call(
      `${config.apiUrl}/collections/mint/${nftId}`,
      (init) => ({
        ...init,
        method: "POST",
      }),
    );
  };

export async function enrichWithCollections<
  T extends { [k: string]: any },
  TPropsToEnrich extends string,
>(array: T[], properties: EnrichmentProperties<T>) {
  const listOfAddresses = exportAddressesByProperties(array, properties);
  const collections = await withClientRequest(requests.getCollectionsByAddress)(
    listOfAddresses,
  );
  const newArray = array.map((item) => {
    const newItem: any = enrichItem(
      item,
      properties,
      collections!,
      (collection) => collection.address!,
    );
    return newItem;
  });

  return newArray as EnrichedObject<T, TPropsToEnrich, Collection>[];
}

const clientRequests = {
  enrichWithCollections,
  validateSlug,
  create: withAuthenticatedClientRequest(create),
  mintForFree: withAuthenticatedClientRequest(mintForFree),
  getPopularCollections: withClientRequest(requests.getPopularCollections),
  getCollections: withClientRequest(requests.getCollections),
  getCollectionsByAddress: withClientRequest(requests.getCollectionsByAddress),
  getCollectionsForArtist: withClientRequest(requests.getCollectionsForArtist),
  getCollectionBySlug: withClientRequest(requests.getCollectionBySlug),
  getSingleCollection: withClientRequest(requests.getSingleCollection),
  getForMint: withClientRequest(requests.getCollectionsForMint),
  updateCollection: withAuthenticatedClientRequest(requests.updateCollection),
};

export default clientRequests;
